import React from 'react';
import BalanceIcon from '@mui/icons-material/Balance';
import AgentConfirmationCard from './AgentConfirmationCard';

interface PanoramaConfirmationData {
  type: 'panorama_confirmation';
  justificativa?: string;
  // true só no card empurrado AO VIVO (via SSE); o card PERSISTIDO (reidratado do
  // histórico no reload) vem sem `active` → renderiza passivo, sem botões, pra não
  // re-rodar o panorama (caro) num clique acidental.
  active?: boolean;
}

interface Props {
  data: PanoramaConfirmationData;
}

/**
 * Card de confirmação do Panorama Jurídico (gate humano antes da pesquisa cara).
 * Ao vivo (active): botões disparam o evento de janela `panoramaDecision`.
 * Histórico (sem active): só o registro da proposta, sem botões.
 */
const PanoramaConfirmation: React.FC<Props> = ({ data }) => (
  <AgentConfirmationCard
    icon={<BalanceIcon style={{ fontSize: 17 }} />}
    title="Rodar o Panorama Jurídico?"
    description={
      'Pesquisa jurídica profunda — levanta teses, fundamentos e variações por tribunal. ' +
      'Entrega resultados mais completos e precisos, mas leva alguns minutos.'
    }
    justificativa={data.justificativa}
    active={data.active}
    runLabel="Rodar Panorama"
    declineLabel="Agora não"
    decidedRunText="▶ Rodando o Panorama Jurídico…"
    decidedDeclineText="✕ Seguindo sem o Panorama, com as buscas diretas."
    passiveText="— proposta do Panorama registrada no histórico —"
    onDecide={(decision) =>
      window.dispatchEvent(new CustomEvent('panoramaDecision', { detail: { decision } }))
    }
  />
);

export default PanoramaConfirmation;
